import { gql } from "@apollo/client"

import { useMutation, InjectedOptions } from "@oysterhr/core"
import {
  TransitionDependentEnrollmentInput,
  TransitionDependentEnrollmentPayload,
} from "@oysterhr/schema"

const TRANSITION_DEPENDENT_ENROLLMENT_MUTATION = gql`
  mutation TransitionDependentEnrollment(
    $dependentEnrollmentId: ID!
    $transitionEvent: BenefitsEnrollmentTransitionEventEnum!
    $coverageEndDate: ISO8601Date
    $cancellationReason: BenefitsEnrollmentCancellationReasonEnum
  ) {
    transitionDependentEnrollment(
      input: {
        dependentEnrollmentId: $dependentEnrollmentId
        transitionEvent: $transitionEvent
        coverageEndDate: $coverageEndDate
        cancellationReason: $cancellationReason
      }
    ) {
      errors
      dependentEnrollment {
        id
        state
        coverageStartDate
        availableEvents
        coverageEndDate
        cancellationReason
      }
    }
  }
`

export const useTransitionDependentEnrollment = (
  options?: InjectedOptions<
    { transitionDependentEnrollment: TransitionDependentEnrollmentPayload },
    TransitionDependentEnrollmentInput
  >,
) => {
  return useMutation<
    { transitionDependentEnrollment: TransitionDependentEnrollmentPayload },
    TransitionDependentEnrollmentInput
  >(TRANSITION_DEPENDENT_ENROLLMENT_MUTATION, {
    ...options,
  })
}
